
        // replaceSrcMethodName from webpack-require-from no longer works in webpack@5 so below we recreate that logic
        // ticket to revisit this change: https://jira.godaddy.com/browse/UXP-8159
        const old = __webpack_require__.l;
        __webpack_require__.l = function new_loadScript(url, done, key, chunkId) {
          let chunkUrl = url;
          try {
            const returnChunk = new URL(url).pathname.split('/').pop().replace(/.min.js|.js/, '');
            // Logic to load chunk from correct path, aka getCDNPath
            chunkUrl = ux.data.cdn[returnChunk] || url;
          } catch (e) {
            // fail silently
          }

          old(chunkUrl, done, key, chunkId);
        }
      